import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state } from 'app/pwa/app.cerebral';
import ActivityModal from './ActivityModal';
import IntroModal from './IntroModal';
import IndicatorModal from './IndicatorModal';
import TagModal from './TagModal';
import OutroModal from './OutroModal';
import LeaderboardModal from './LeaderboardModal';
import StreakModal from './StreakModal';
import GoalModal from './GoalModal';
import NpsModal from './NpsModal';

const deps = {
  showActivityModal: state.challenge.activityModal.showActivityModal,
  showIndicatorModal: state.challenge.info.showIndicatorModal,
  showTagModal: state.challenge.tagModal.show,
  showIntroModal: state.challenge.tutorial.showIntroModal,
  showOutroModal: state.challenge.tutorial.showOutroModal,
  showLeaderboardModal: state.challenge.info.showLeaderboardModal,
  showStreakModal: state.challenge.info.showStreakModal,
  showGoalModal: state.challenge.info.showGoalModal,
  showNpsModal: state.challenge.info.showNpsModal,
};

export function Modals({
  showActivityModal,
  showIndicatorModal,
  showTagModal,
  showIntroModal,
  showOutroModal,
  showLeaderboardModal,
  showStreakModal,
  showGoalModal,
  showNpsModal,
}: typeof deps & ConnectedProps): React.ReactElement {
  if (showActivityModal) return <ActivityModal />;
  if (showIndicatorModal) return <IndicatorModal />;
  if (showTagModal) return <TagModal />;
  if (showIntroModal) return <IntroModal />;
  if (showOutroModal) return <OutroModal />;
  if (showLeaderboardModal) return <LeaderboardModal />;
  if (showStreakModal) return <StreakModal />;
  if (showGoalModal) return <GoalModal />;
  if (showNpsModal) return <NpsModal />;

  return null;
}

export default connect(deps, Modals);
